Promise = require 'bluebird'
PluginView = require 'app/scripts/views/plugin/plugin-view'
sandboxParams = require 'app/scripts/data/plugin-iframe-sandbox'
t = require('app/scripts/views/internal/teacup-with-helpers')()

template = t.renderable ({ content } = {}) ->
  switch content.type
    when 'iframe'
      t.iframe '.plugin-iframe',
        allow: 'microphone; camera'
        sandbox: sandboxParams
        src: content.url
      t.div '.plugin-iframe-popover-overlay'
  return

module.exports = class PluginOverlayView extends PluginView
  initialize: ({ @content }) ->
    @retain(@content)

  className: 'plugin-overlay js-plugin-iframe-container'

  renderOnce: ->
    @$el.html(template({ @content }))
    @initIFrames(@model)
    @
